(() => {
  const createStore = (storage, origin) => {
    const key = 'fara-crate-v1';
    const limits = {saved: 60, heard: 30};
    let state = {saved: [], heard: []}, persistent = true;
    const clean = entry => {
      if (!entry || typeof entry.handle !== 'string' || !/^[a-z0-9][a-z0-9-]{0,199}$/.test(entry.handle)) return null;
      let image = '';
      try {
        const url = new URL(entry.image || '', origin);
        if (typeof entry.image === 'string' && entry.image && url.protocol === 'https:' && (url.origin === origin || url.hostname === 'cdn.shopify.com')) image = url.href;
      } catch {}
      let preview = '';
      try {
        const url = new URL(entry.preview);
        if (typeof entry.preview === 'string' && entry.preview.length < 2000 && url.protocol === 'https:' && ['cdn.shopify.com', 'cdn.spatialx.media'].includes(url.hostname)) preview = url.href;
      } catch {}
      return {handle: entry.handle, title: typeof entry.title === 'string' ? entry.title.slice(0, 300) : entry.handle, artist: typeof entry.artist === 'string' ? entry.artist.slice(0, 150) : '', image, preview};
    };
    const list = (entries, limit) => {
      const seen = new Set();
      return (Array.isArray(entries) ? entries : []).slice(0, 500).flatMap(entry => {
        const item = clean(entry);
        if (!item || seen.has(item.handle)) return [];
        seen.add(item.handle); return [item];
      }).slice(0, limit);
    };
    const load = raw => {
      let value; try { value = JSON.parse(raw || '{}'); } catch { value = {}; }
      state = {saved: list(value?.saved, limits.saved), heard: list(value?.heard, limits.heard)};
    };
    const refresh = () => {
      if (!persistent) return;
      try { load(storage.getItem(key)); } catch { persistent = false; }
    };
    const persist = () => { try { storage.setItem(key, JSON.stringify(state)); } catch { persistent = false; } };
    refresh();
    return {
      key, clean,
      snapshot: () => ({saved: state.saved.map(item => ({...item})), heard: state.heard.map(item => ({...item})), persistent}),
      reload: raw => { load(raw); },
      toggle(entry) {
        const item = clean(entry); if (!item) return 'invalid';
        refresh();
        const index = state.saved.findIndex(record => record.handle === item.handle);
        if (index >= 0) {state.saved.splice(index, 1); persist(); return 'removed';}
        if (state.saved.length >= limits.saved) return 'full';
        state.saved.unshift(item); persist(); return 'saved';
      },
      heard(entry) {
        const item = clean(entry); if (!item) return false;
        refresh();
        const previous = state.heard.find(record => record.handle === item.handle);
        state.heard = [{...item, image: item.image || previous?.image || ''}, ...state.heard.filter(record => record.handle !== item.handle)].slice(0, limits.heard);
        persist(); return true;
      },
      clearHistory() { refresh(); state.heard = []; persist(); }
    };
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = createStore;
  else window.FaraCrateStore = createStore;
})();
